jQuery(document).ready(function ($) {
  jQuery(".products-list-kitfesta .product-list-carrousel").slick(
    {
      arrows: true,
      dots: true,
      dotsClass: "slick-dots-pdp",
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      prevArrow:
        '<button aria-label="Previous" class="slick-prev-black"></button>',
      nextArrow: '<button aria-label="Next" class="slick-next-black"></button>',
      responsive: [
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2.6,
            arrows: false,
          },
        },
        {
          breakpoint: 760,
          settings: {
            slidesToShow: 1.6,
            arrows: false,
          },
        },
        {
          breakpoint: 380,
          settings: {
            slidesToShow: 1.4,
            arrows: false,
          },
        },
      ],
    },
    1000
  );
});
